import {afterDomIsReady} from '../utils/whenLoaded';
import {initializePatientStorage} from '../stateHandler';
import {assert} from '../utils/assert';
import {getInputById} from '../utils/formFields';

export default () => afterDomIsReady(() => {

	// set default date to today
	const currentTime = new Date();
	const month = currentTime.getMonth() + 1;
	const day = currentTime.getDate();
	const year = currentTime.getFullYear();

	const dateEl = getInputById('patient-examinationDate');
	dateEl.value = (new Date()).toISOString().substr(0, 10);


	// save fields value to local storage on submit
	const formEl = document.getElementById('patient');
	assert(formEl !== null);
	formEl.addEventListener('submit', function (ev) {
		const storage = initializePatientStorage();

		const [year, month, day] = dateEl.value.split('-');
		const examinationDate = `${parseInt(day)}. ${parseInt(month)}. ${year}`;

		storage.update({
			degree: getInputById('patient-degree').value,
			lastName: getInputById('patient-lastName').value,
			firstName: getInputById('patient-firstName').value,
			examinationDate: examinationDate,
		});

		const targetEl = getInputById('patient-questionnaire')
		window.location.href = `${targetEl.value}.html`;
		ev.preventDefault();
	});

	const directFormEl = document.getElementById('patient-none');
	assert(directFormEl !== null);
	directFormEl.addEventListener('submit', function (ev) {
		const targetEl = getInputById('patient-none-questionnaire')
		window.location.href = `${targetEl.value}.html`;
		ev.preventDefault();
	});
});
